import { Divider } from '@dotfile/frontend/shared/design-system';

export const LayoutDivider = () => {
  return <Divider py="1" />;
};
